import {
  webviewOnReady,
  webviewOnShow,
  webviewOnHidden,
  webviewOnUnload
} from "@ht/utils";

export const initWebviewHook = () => {
  webviewOnReady(() => {
    console.log("webviewOnReady");
  });

  webviewOnShow(() => {
    console.log("webviewOnShow");
  });

  webviewOnHidden(() => {
    console.log("webviewOnHidden");
  });

  webviewOnUnload(() => {
    console.log("webviewOnUnload");
  });
};
